import styled from 'styled-components';

export const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0 24px;
  overflow: hidden;

  @media (min-width: 768px) {
    padding: 0 45px;
  }

  @media (min-width: 1024px) {
    padding: 0 95px;
  }

  @media (min-width: 1280px) {
    padding: unset;
  }
`;

export const Title = styled.h1`
  font-size: 48px;
  font-style: normal;
  font-weight: 800;
  line-height: 52px;
  letter-spacing: -1.8px;
  text-align: left;
  margin-bottom: 48px;

  @media (max-width: 768px) {
    font-size: 48px;
    line-height: 52px;
  }

  @media (max-width: 640px) {
    font-size: 32px;
    line-height: 1;
  }
`;

export const EssayInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;

  @media (max-width: 640px) {
    flex-direction: column;
  }
`;

export const EssayInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  margin-bottom: 32px;
  margin-right: 48px;

  &:last-child {
    @media (max-width: 640px) {
      padding-top: 32px;
      margin-bottom: 0px;
      border-top: 1px solid #191a1a;
    }
  }
`;

export const EssayInfoTitle = styled.span`
  color: var(--color-primary-gray-05, #ddd);
  font-family: Aprova Nova;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 100%; /* 16px */
  color: #ddd;
`;

export const EssayInfoText = styled.span`
  color: var(--neutral-color-000, #fff);
  font-family: Aprova Nova;
  font-size: 64px;
  font-style: normal;
  font-weight: 700;
  line-height: 65%; /* 41.6px */
  letter-spacing: -3.2px;
`;

export const EssayInfoDetail = styled.span`
  color: var(--neutral-color-100, #e5e6e7);
  font-family: Aprova Nova;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -1px;
`;

export const EssayInfoTime = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 4px;
`;

export const EssayTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const EssaySubTitle = styled.div`
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px;
  letter-spacing: -1px;
`;

export const ShowAllButton = styled.button`
  font-size: 16px;
  position: relative;
  line-height: 24px;
  letter-spacing: -0.6px;
  color: var(--color-primary-gray-05, #ddd);
  text-decoration: underline;
`;

export const EssayListContainer = styled.div`
  display: block;
  margin-top: 40px;
`;

export const EssayList = styled.ul<{ columns: number }>`
  list-style: none;
  display: grid;
  grid-template-columns: repeat(${(props) => props.columns}, 1fr);
  margin-top: 14px;
  gap: 20px;
`;

export const Breadcrumb = styled.span`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.6px;
  color: #caccce;
  cursor: pointer;
`;
